<template>
  <div class="commerce-order-delivery-wall">
    <p class="header" @click="close">
      <i class="fa fa-chevron-left" style="padding-right: 8px" />
      <span v-if="isOnTheWay">{{
        $t("commerce-order.delivery-on-the-way")
      }}</span>
      <span v-else>{{ $t("commerce-order.delivery-details") }}</span>
    </p>
    <div v-if="isOngoing" class="button is-light has-text-danger wrong-address" @click="incorrectAddress">
      {{ $t("commerce-order.incorrect-address-?") }}
    </div>

    <div class="card">
      <div class="card-content">
        <div style="display: flex; padding: 12px">
          <div class="left has-text-centered">
            <p><i class="fa fa-store-alt has-text-grey" /></p>
            <p>
              <i class="fa fa-ellipsis-v fa-sm" style="color: grey" />
            </p>
            <p><i class="fa fa-map-marker-alt has-text-success" /></p>
          </div>
          <div class="right has-text-left">
            <p class="clamp" style="height: 48px">
              {{ $t("commerce-order.order-from") }}
              <a :href="googleMapPickup" target="_blank" class="has-text-link">
                {{ pickupName }}
                <!-- <i class="fa fa-directions fa-lg" /> -->
              </a>
            </p>
            <p v-if="t.data.dropoff_stop" class="single-line">
              {{ $t("commerce-order.delivering-to") }}
              <a :href="googleMapDropoff" target="_blank" class="has-text-link">
                {{ dropoffName }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isOnTheWay">
      <RideBookingDriver :driver="t.driver" />
    </div>
    <div v-else class="card delivery-info">
      <div v-if="isOngoing">
        <p style="margin-bottom: 2px">
          <i class="fa fa-motorcycle" @click="copyTransactionID" />
          <i>{{ $t("commerce-order.driver-details-will-show-here") }}</i>
        </p>
        <p @click="callShop">
          <i class="fa fa-phone" />
          <i>
            <i class="has-text-link link">{{ $t("call-the-shop") }}</i>
            {{ $t("commerce-order.if-you-have-any-questions") }}
          </i>
        </p>
      </div>
      <div v-else>
        <p style="margin-bottom: 4px" @click="showTimeAgo">
          <i class="fa fa-check-circle has-text-success" style="margin-right: 6px" />
          <i class="has-text-black">{{
            $t("commerce-order.delivery-has-been-completed")
          }}</i>
        </p>
        <p @click="triggerHelp">
          <i class="fa fa-headset" style="margin-right: 6px" />
          <i>
            <i class="has-text-link link">Contact TUK Customer Support</i> if
            you require assistance.
          </i>
        </p>
      </div>
    </div>

    <div v-if="updating" class="update-btn tag" style="border: 1px solid white">
      Updating&nbsp;
      <i class="fa fa-spinner fa-spin" />
    </div>
    <div v-else-if="isOngoing && !t.data.hide_driver" class="update-btn tag pulse" @click="update">
      <i class="fa fa-redo-alt fa-sm" />&nbsp;
      <span v-if="isOnTheWay" @click="pingDriver">{{
        $t("commerce-order.update-driver-location")
      }}</span>
      <span v-else>{{ $t("commerce-order.update-order") }}</span>
    </div>
    <div v-else-if="isOngoing && t.data.hide_driver" class="update-btn tag is-info" @click="hiddenDriverInfo">
      <i class="fa fa-motorcycle" style="margin-right: 6px" />Driver is enroute
      to dropoff
    </div>
    <div v-else class="update-btn tag is-success">
      <i class="fa fa-check-circle" style="margin-right: 6px" />Delivery
      completed {{ updatedMinutesAgo }} mins ago
    </div>

    <div v-if="isOnTheWay" class="marquee-wrapper">
      <marquee-text :duration="3">
        <div class="marquee" style="width: 100vw; padding-top: 5px">
          <img :src="vehicleIcon" />
        </div>
      </marquee-text>
    </div>

    <CommerceOrderDeliveryMap :z="z" :delivery="t" :hideDriver="!isOnTheWay || t.data.hide_driver" :notes="notes" />
  </div>
</template>

<script>
import CommerceOrderDeliveryMap from "@/components/CommerceOrderDeliveryMap";
import RideBookingDriver from "@/components/RideBookingDriver";
import geo from "@/geo";
import vehicles from "@/vehicles";

export default {
  name: "CommerceOrderDeliveryWall",
  components: { CommerceOrderDeliveryMap, RideBookingDriver },
  props: {
    z: Number,
    t: Object,
    notes: String,
    businessRef: String,
  },
  watch: {
    z() {
      console.log("z updated", this.z);
      this.updating = true;
      setTimeout(() => (this.updating = false), 1000);
    },
  },
  data() {
    return {
      updating: false,
      pingedDriver: false,
      placeholderPic: this.$store.state.menuItemPlaceholderPic,
    };
  },
  computed: {
    vehicleIcon() {
      return vehicles.img("Motorbike");
    },
    updatedMinutesAgo() {
      var updatedAt = new Date(this.t.updated_at);
      return Math.round((new Date() - updatedAt) / (1000 * 60));
    },
    isOngoing() {
      if (this.t.state === "alighted") return false; // alighted is still on_going for 24 hours
      return this.t.is_ongoing;
    },
    isOnTheWay() {
      if (this.t.state === "enroute") return true;
      // if (this.t.state === "alighted") {
      //   if (this.updatedMinutesAgo < 60) return true;
      // }
      return false;
    },
    driverPic() {
      return this.t.driver.profile_pic_url || this.placeholderPic;
    },
    shopContactable() {
      return true; // should be false if order is completed / cancelled and older than x hours
    },
    driverContactable() {
      if (!this.t) return false; // may not have driver yet
      var states = [
        "initiated",
        "confirmed",
        "driver_arrived",
        "cancelled_by_driver",
      ];
      if (states.includes(this.t.state)) return false;
      // also return false if cancelled alighted/no_show and older than x hours
      return true;
    },
    pickupName() {
      return this.t.data.pickup_stop.name || this.$t("ride.pin-location");
      //   return this.shortenString(this.t.data.pickup_stop.name, 40);
    },
    dropoffName() {
      return this.t.data.dropoff_stop.name || this.$t("ride.pin-location");
      //   return this.shortenString(this.t.data.dropoff_stop.name, 40);
    },
    googleMapPickup() {
      var a = this.t.data.pickup_stop;
      return `http://www.google.com/maps/place/${a.lat},${a.lon}`;
    },
    googleMapDropoff() {
      var a = this.t.data.dropoff_stop;
      return `http://www.google.com/maps/place/${a.lat},${a.lon}`;
    },
  },
  mounted() { },
  methods: {
    close() {
      this.$emit("close");
    },
    update() {
      this.$emit("update");
    },
    hiddenDriverInfo() {
      var msg = `Driver is currently enroute to dropoff<br>Driver location will not show on map<br>Call driver if you need to speak to them`;
      this.infoToast(msg, "top", 20 * 1000);
    },
    copyTransactionID() {
      if (!this.isSuperUser()) return;
      this.$copyText(this.t.id);
      this.infoToast(`Copied Delivery Transaction ID<br>${this.t.id}`);
    },
    driverStale() {
      if (!this.t.driver) return false;
      return this.secondsAgo(this.t.driver.user_state.updated_at) < 60;
    },
    pingDriver() {
      var msg = `We've asked the driver 🏍<br>to update their GPS location 📍<br>Please check back in a minute 🙏🏼`;
      this.infoToast(msg, "bottom", 10000);
      if (this.pingedDriver) return;
      if (!this.driverStale()) return; // don't ping if driver position is not stale
      this.pingedDriver = true;
      this.$store
        .dispatch("sendMessageToUser", {
          user_id: this.t.driver.id,
          message: "📍PLEASE UPDATE YOUR GPS LOCATION🧭🙏🏼",
          type: "push", // send type: sms or push
        })
        .catch((err) => console.log("pingDriver to update their GPS", err)); //this.apiError(err)
    },
    showTimeAgo() {
      var msg = `Updated ${this.updatedMinutesAgo} mins ago`;
      this.infoToast(msg, "top");
    },
    incorrectAddress() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-map-marker-alt' style='color:red'></i>&nbsp;Incorrect address?
        </p>
        <p style='margin-bottom:10px'>
        Provide a google maps link or the exact coordinates of the correct address.
        </p>
        <p style='margin-bottom:10px'>Contact Support if you need help.</p>
        </div>`,
        input: "textarea",
        inputPlaceholder: `https://goo.gl/maps/qmF5x...
or
18.7871887, 98.994431`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Submit Address",
        cancelButtonText: this.$t("cancel"),
        // cancelButtonText: "Contact Support",
        inputValidator: (val) => {
          if (!val || val.length < 8)
            return "Enter a valid google maps link or coordinates";
        },
      }).then((val) => {
        if (val.value) {
          // send email or something
          var msg = `Please send a chat to customer support<br>so we can expedite this request`;
          this.infoToast(msg, "top", 10000);
          this.sendEmailCommerceOrderWrongAddress(val.value);
          // setTimeout(() => this.contactFBMessengerSupport(), 3000);
          this.promptCustomerSupport();
        }
        // if (val.dismiss === "cancel") {
        //   this.sendEmailCommerceOrderWrongAddress();
        //   this.infoToast("Opening customer support...");
        //   setTimeout(() => this.contactFBMessengerSupport(), 1500);
        // }
      });
    },
    promptCustomerSupport() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-headset' style='color:blue'></i>&nbsp;Incorrect address?
        </p>
        <p style='margin-bottom:10px'>
        If the correct address is far off or if the delivery driver is already on the way, 
        please send a chat to customer support alerting us to the address change so we can fix it ASAP.
        </p>
        </div>`,

        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: "Contact Support",
      }).then((val) => {
        if (val.value) {
          // this.sendEmailCommerceOrderWrongAddress();
          this.infoToast("Opening customer support...");
          setTimeout(() => this.contactFBMessengerSupport(), 1500);
        }
      });
    },
    sendEmailCommerceOrderWrongAddress(newAddress) {
      var userCoords = this.$store.getters.getUserLatLon;
      var userCoordsString = this.$store.getters.getUserLocationString;
      var dist = geo.distanceToUserInMeters(this.dropoff, userCoords);
      var supportType = "wrong_address";
      var googleMapURL = null;
      if (userCoordsString) {
        googleMapURL = `http://www.google.com/maps/place/${userCoordsString}`;
      }
      if (dist === 999000) supportType = "no_gps"
      var obj = {
        topic: "commerce_order_wrong_address",
        type: "commerce_order_wrong_address",
        user_id: this.$store.state.user.id,
        uuid: this.$store.getters.getUUID,
        phone_number: this.$store.getters.phoneNumber,
        name: this.$store.getters.realName,
        support_type: supportType,
        new_address: newAddress,
        order: this.businessRef,
        app: process.env.VUE_APP_TITLE,
        user_coords_string: userCoordsString,
        distance_meters: `${dist}m`,
        google_maps: googleMapURL,
      };
      this.$store.dispatch("sendEmail", obj).catch((err) => console.error(err));
      var msg = `🎧📌 [ ${supportType} ] ${this.businessRef} 🙋🏻 ${this.$store.getters.realName} -- ${dist}m`;
      this.sendSuperuserNotification(msg);
    },
    triggerHelp() {
      this.$emit("triggerHelp");
      this.close();
    },
    callShop() {
      this.$emit("callShop");
    },
    // copyOrderURL() {
    //   this.$copyText(window.location.href);
    //   this.infoToast("Info copied to clipboard");
    // },
    // gotoChatSupport() {
    //   this.copyOrderURL();
    //   this.infoToast("Opening chat now...");
    //   setTimeout(() => {
    //     window.open("https://m.me/tukapp", "_blank");
    //   }, 1000);
    // },
    // callShop() {
    //   this.callPhoneNumber(this.t.business.data.phone_number);
    // },
    // callDriver() {
    //   this.callPhoneNumber(this.t.driver.phone_number);
    // },
  },
};
</script>

<style scoped>
.commerce-order-delivery-wall {
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  max-width: 700px;
  overflow: hidden;
  text-align: left;
  background-color: white;
  z-index: 3;
  padding: 0;
  margin: auto;
  /* display: flex; */
  /* flex-flow: column; */
  height: 100%;
}

.top {
  border: 1px dotted grey;
  flex: 0 1 auto;
  /* Shorthand for flex-grow: 0, flex-shrink: 1, flex-basis: auto */
}

.bottom {
  border: 1px dotted green;
  flex: 1 1 auto;
}

.header {
  /* position: relative; */
  padding: 12px;
  padding-left: 12px;
  /* padding-bottom: 4px; */
  /* margin-bottom: 10px;
  margin-top: 10px; */
  font-size: 1.1em;
  font-weight: 500;
  z-index: 4;
  background-color: #ddd;
}

.card-content {
  padding: 0;
  margin: 0;
}

.card-content .fa {
  margin-right: 10px;
}

.column {
  padding: 0;
  margin: 0;
}

.driver-pic {
  object-fit: cover;
  border-radius: 5px;
  height: 80px;
  width: 80px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

/* .hint {
  font-weight: 500;
  font-size: 0.8em;
} */
/* a {
  white-space: nowrap;
  text-overflow: ellipsis;
} */
.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* padding-right: 4px; */
}

.single-line {
  width: calc(100vw - 44px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.update-btn {
  position: absolute;
  left: 0px;
  top: 248px;
  z-index: 3;
  margin: 10px;
  border-radius: 25px;
  box-shadow: 1px 1px 3px grey;
  background-color: white;
  color: blue;
  border: 1px solid blue;
}

.update-btn.is-success {
  border: initial;
  font-weight: 500;
  font-size: 0.85em;
}

.problem-btn {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
  padding: 16px 6px;
  /* background-color: rgba(255, 255, 255, 0.7); */
  /* border-radius: 25px; */
  /* box-shadow: 1px 1px 3px grey; */
  color: grey;
  font-weight: 500;
  font-size: 0.75em;
  /* max-width: 60px; */
}

.wrong-address {
  position: absolute;
  right: 0;
  top: 0;
  margin: 6px;
  z-index: 5;
  box-shadow: 0 0 6px #bbb;
}

.delivery-info {
  font-size: 0.95em;
  padding: 12px;
  color: grey;
  height: 102px;
  overflow: scroll;
}

.delivery-info .fa {
  width: 20px;
  margin-right: 10px;
  text-align: center;
}

@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px yellow inset;
  }

  100% {
    box-shadow: 0 0 0 15px yellow inset;
  }
}

.pulse {
  animation: shadow-pulse-gold 1s infinite ease-out;
}

.marquee-wrapper {
  position: absolute;
  left: 0px;
  top: 288px;
  z-index: 3;
}

.marquee img {
  height: 60px;
  width: 60px;
  transform: scaleX(-1);
}

.marquee .tag {
  margin-left: 20px;
}
</style>